import type { Article } from "~/models/articleModel";
import { ImageAlignment } from "~/models/imageAlignment";

export const GlassReplacementIntro: Article = 
    {
        id: 1,
        title: "Glass Repair and Replacement",
        // image: "/broken.jpeg",
        // imageAlignment: ImageAlignment.RIGHT,
        // alt: "Glass Repair and Replacement",
        actionText: "Explore the outcomes",
        bgImage: "/right_section_bg_broken.png",
        bgImageMobile: "/right_section_bg_broken_mobile.png",
        actionLink: "portfolio",
        actionIcon: "mdi-arrow-right",
        actionVariant: "text",
        sections: [
            { 
                id: 1,
                keywords: ["Elite Glazing Solutions LLC", "glass repair and replacement services"],
                heading: "Elite Glazing Solutions LLC: Premier Glass Repair & Replacement Services in Denver", 
                content: "Looking for reliable glass repair and replacement services in the Denver metro area? Look no further than Elite Glazing Solutions LLC. With years of experience and a team of highly skilled professionals, we deliver unmatched craftsmanship and exceptional customer service.",
            },
            {
                id: 2,
                keywords: ["Elite Glazing Solutions LLC"],
                content: "From repairing cracked windows to replacing shattered storefront glass, our technicians handle every job with precision and efficiency. Using cutting-edge technology and industry-best practices, Elite Glazing Solutions LLC ensures top-tier results for every project, big or small."
            },
        ],
    }
